import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { State as Root } from '.'
import cdn from '@/http/cdn'
import leads from '@/http/leads'

export interface FormContent {
  school: string
  chief: string
  phone: string
}

export interface Item {
  id: string
  cover: string
  content: string[]
  noApply?: boolean
}
export interface Home {
  header: string
  footer: string
}
export interface Buttons {
  applyButton: string
  backButton: string
}

export interface State {
  code: string
  url: string
  channel?: string
  accountId?: number
  materialId?: number
  index?: number
  home?: Home
  items?: Item[]
  buttons?: Buttons
  title?: string
}

export const state: Action<State> = () => ({
  code: null,
  url: '/xbshow/moonglow/contest/config.json',
  channel: null,
  accountId: 0,
  materialId: 0,
  index: null,
  home: null,
  buttons: null,
  items: null,
  title: null
})

export const getters: GetterTree<State, Root> = {
  item: state => (state.index != null ? state.items[state.index] : null),
  channel: state => state.channel
}

export const mutations: MutationTree<State> = {
  setIndex(state, index: number) {
    state.index = index
  },
  setChannel(state, channel: string) {
    state.channel = channel
  },
  setMiddlegroundParam(state, { accountId, materialId }) {
    state.accountId = parseInt(accountId) || 0
    state.materialId = parseInt(materialId) || 0
  },
  setConfig(state, { home, buttons, items, title, code }) {
    state.code = code
    state.home = home
    state.buttons = buttons
    state.items = items
    state.title = title
  }
}

export const actions: ActionTree<State, Root> = {
  select({ commit, state }, index: number) {
    if (!state.items) {
      return
    }
    if (index < 0 || index >= state.items.length) {
      throw new Error('要查看的对象不存在')
    }
    commit('setIndex', index)
  },
  pick({ commit, state }, id: string) {
    if (!state.items) {
      return
    }
    const index = state.items.findIndex(e => e.id === id)
    if (index < 0) {
      throw new Error('要查看的对象不存在')
    }
    commit('setIndex', index)
  },
  deselect({ dispatch }) {
    return dispatch('select', null)
  },
  async fetch({ state, commit }) {
    const res: any = await cdn.get(state.url, {
      params: {
        ver: Date.now()
      }
    })
    commit('setConfig', res)
  },
  async submit({ getters, state }, data: FormContent) {
    const item: Item = getters.item
    if (!item) {
      return
    }
    await leads.post(
      '/form/addForm',
      JSON.stringify({
        templateId: state.code,
        contestId: item.id,
        school: data.school,
        chief: data.chief,
        phone: data.phone,
        channel: state.channel,
        accountId: state.accountId,
        materialId: state.materialId
      }),
      {
        headers: {
          'content-type': 'text/plain'
        }
      }
    )
  }
}

export const namespaced = true
